<template lang="pug">
  app-modal(
    :titulo="'Desarquivar processo - ' + numeroProcesso",
    @closeModal="closeModal"
  )
    template(slot="body")
      validation-observer(ref='validation' tag='form')
        app-display(
          label="Nome do interessado:",
          :content="processo.nomeRazaoSocialInteressado"
        )
        app-display(
          label="CPF/CNPJ do Interessado:",
          :content="processo.cpfCnpjInteressado"
        )
        app-label.p-top.label-desarquivamento(
          v-if="emitirBoleto && !isMaranhao && !isAmapa"
          label="Opções de desarquivamento:",
          :required="true"
        )
        validation-provider(:rules="isObrigatorio()", v-slot="{ errors }", v-if="emitirBoleto && !isMaranhao && !isAmapa")
          el-row
            el-radio-group.input(
            v-if="!isMaranhao"
              v-model="boleto",
              name="boleto",
              :class="{'erro' : errors.length}"
              :disabled="processo.tipoCodigo === 'REGULARIZACAO_URBANA' || setorLogado === 'GDA'"
            )
              div.input(:class="{'erro' : errors.length}")
                el-radio(:label="true" :disabled="isReurb()") Gerar boleto
                el-radio(:label="false" :disabled="isReurb()") Não gerar boleto
            span.help.erro {{ errors[0] }}
        p(v-if="boleto !== null") {{ boleto ? `O boleto será gerado no valor de ${valorBoleto ? formatTotal(valorBoleto) : 'xx.xx'} reais, com data de vencimento para 30 dias após a emissão.` : 'O processo será desarquivado automaticamente.' }}
        app-label.p-top.label-desarquivamento(
          label="Mensagem:",
          :required="true"
        )
        validation-provider(rules="required", v-slot="{ errors }")
          app-editor-texto.input(
            :value="mensagem",
            @onTextChange="setMensagem"
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
        el-row(v-if="isMaranhao").margin-top
          p.label.mt-20 Anexos mensagem
        el-row(v-if="isMaranhao").margin-top
          validation-provider(v-slot="{ errors }")
            app-anexo(
              :id="'upload-anexo-despacho'",
              @removeFile="removeFile",
              @uploadFile="uploadFile",
              :exibirDownload="false",
              :files="documentos",
              scope="anexos",
              v-model="documentos",
              :tipoExibir="'ANEXO_ANALISE'"
            )

    template(slot="footer")
      .flex
        el-button.btn(
          type="default",
          size="small",
          @click="closeModal"
        )
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn(
          type="success",
          size="small"
          @click="enviar"
        )
          span.center
            i.fa.fa-share-square
            b(v-if="!isMaranhao && !isAmapa") &nbsp Enviar
            b(v-else) &nbsp Desarquivar
</template>
<script>
import { mapActions, mapState } from 'vuex'
import utils from '@/utils/utils'
import AppModal from '@/components/AppModal'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppLabel from '@/components/AppLabel'
import AppDisplay from '@/components/AppDisplay'
import AppAnexo from '@/components/AppAnexo'
const { desarquivamentoProcesso } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppModal,
    AppEditorTexto,
    AppLabel,
    AppDisplay,
    AppAnexo
  },

  data () {
    return {
      mensagem: '',
      emitirBoleto: true,
      boleto: this.processo.tipoCodigo === 'REGULARIZACAO_URBANA' ? false : null,
      valorBoleto: 0,
      isMaranhao: process.env.ESTADO === 'ma',
      isAmapa: process.env.ESTADO === 'ap',
      documentos: []
    }
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idProcesso: {
      required: true
    },
    numeroProcesso: {
      required: true
    },
    processo: {
      type: Object,
      required: true
    }
  },

  async created () {
    if (!this.isMaranhao && !this.isAmapa) {
      await this.getCustoBoletoDesarquivamento(this.processo.numeroProtocolo).then(res => {
        this.valorBoleto = res
      })

      this.emitirBoleto = desarquivamentoProcesso.emitirBoleto || desarquivamentoProcesso.regrasExclusaoTipoProcesso(this.processo.tipoCodigo)
      if (!this.emitirBoleto) {
        this.boleto = false
      }

      if (this.setorLogado === 'GDA' && this.processo.tipoCodigo !== 'REGULARIZACAO_URBANA') {
        this.boleto = true
      }
    }
  },

  computed: {
    ...mapState({
      setorLogado: state => state.auth.usuarioLogado.perfilSelecionado.setor.codigo
    })
  },

  methods: {
    ...mapActions({
      desarquivarProcesso: 'processo/desarquivarProcesso',
      getCustoBoletoDesarquivamento: 'processo/getCustoBoletoDesarquivamento',
      gerarBoletoDesarquivamento: 'processo/gerarBoletoDesarquivamento'
    }),

    formatTotal (valor) {
      return utils.padraoMoedaBrasil.format(valor)
    },

    closeModal () {
      this.$confirm(
        'Ao fechar a tela, os dados preenchidos serão perdidos e o desarquivamento será cancelado. Tem certeza que seja confirmar esta ação?',
        'Atenção',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(() => {
          this.$emit('closeModal')
        })
        .catch(() => {
        })
    },
    async enviar () {
      if (!await this.checkValidacao()) {
        return
      }

      this.$confirm(
        'Ao confirmar essa ação, o processo será desarquivado. Tem certeza que deseja confirmar essa ação?',
        'Atenção',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(async (action) => {
          const data = {
            idProcesso: this.idProcesso,
            dados: {
              boleto: this.boleto,
              mensagem: this.mensagem,
              valorTotal: this.valorBoleto,
              anexos: this.documentos
            }
          }
          if (this.boleto && !this.isMaranhao && !this.isAmapa) {
            await this.gerarBoletoDesarquivamento(data).then((data) => {
              this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, `Boleto gerado com sucesso`)
            }).catch((e) => {
              this.showNotificacao(this.$messages.TIPO_ERRO, this.$messages.TITULO_ERRO, 'Erro ao gerar boleto')
            })
          } else {
            await this.desarquivarProcesso(data).then((data) => {
              this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, `Processo desarquivado com sucesso. Retornando para ${data.setor}`)
            }).catch((e) => {
              this.showNotificacao(this.$messages.TIPO_ERRO, this.$messages.TITULO_ERRO, 'Erro ao desarquivar processo')
            })
          }
        }).catch(() => {
        }).finally(() => {
          this.$emit('closeModal')
          this.$emit('refresh')
        })
    },
    setMensagem (value) {
      this.mensagem = value
    },
    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },
    isReurb () {
      return this.processo.tipo === 'REURB-S'
    },
    isObrigatorio () {
      return this.isReurb() ? '' : 'required'
    },
    async uploadFile (file) {
      this.documentos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },
    removeFile (file) {
      const arquivo = this.documentos.findIndex(obj => obj === file)
      this.documentos.splice(arquivo, 1)
    }
  }
}
</script>
<style>

.divider {
  border-bottom: solid 2px #dfe4ed;
  width: 100%;
}

.margin40 {
  margin-top: 40px;
}

.padding {
  padding-top: 10px;
}

.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

.label-desarquivamento {
  display: inline-block;
  padding-right: 10px;
  font-weight: bold;
}

.p-top{
  padding-top: 10px;
}

.mt-20 {
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalDesarquivarProcesso.vue